import * as code from '../code';
import * as ropc from '../ropc';
import { env } from '../utils';

/**
 * Hook to use to get the correct handles for logging in.
 */
export const withSession = (() => {
  if (env.FLOW === 'code') {
    return code.withSession;
  }

  if (env.FLOW === 'ropc') {
    return ropc.withSession;
  }

  throw new Error('@boss/auth is incorrectly configured.');
})();

export default withSession;
